/* eslint-disable sonarjs/cognitive-complexity */
'use client';

import { ArrowRightIcon } from '@ahamove/icons/subscription';
import { cn, formatCurrency } from '@ahm/common-helpers';
import {
  Avatar,
  Box,
  Card,
  Group,
  Stack,
  Text,
  rem,
  Badge,
  Pill,
} from '@mantine/core';
import { useRouter } from 'next/navigation';
import { useLocale } from 'next-intl';
import styles from './subscription-styles.module.css';
import { ROUTES } from '@/config/router';
import { assetPrefix } from '@/lib/constants';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';
import { useLocaleSuffix } from '@/navigation';

type SubscriptionItemProps = {
  data?: any;
  isHighlight?: boolean;
};

export default function SubscriptionItem({
  data,
  isHighlight = false,
}: SubscriptionItemProps) {
  const router = useRouter();
  const isMobile = useIsMobile();
  const localSuffix = useLocaleSuffix();

  const handleClickSubscription = () => {
    router.push(`${ROUTES.subscriptionDetail(data._id)}`);
  };
  const locale = useLocale();
  if (!data) return null;
  return (
    <Card
      withBorder
      className={cn('relative cursor-pointer rounded-xl', {
        [styles.bordergradient]: isHighlight,
      })}
      classNames={{
        root: styles.cardSection,
      }}
      radius={rem(12)}
      m={0}
      w="100%"
      onClick={handleClickSubscription}
    >
      {/* <CustomPill /> */}
      <Card.Section>
        <Group
          justify="space-between"
          align="flex-start"
          gap={8}
          p={isMobile ? rem(8) : rem(12)}
          wrap="nowrap"
        >
          <Avatar
            style={{ flexShrink: 0 }}
            radius={rem(8)}
            src={data.icon_url}
            h={109}
            w={109}
            alt={data._id}
          >
            <Avatar
              src={`${assetPrefix}/static/images/sub-thumbnail.webp`}
              style={{ flexShrink: 0 }}
              radius={rem(8)}
              h={109}
              w={109}
              alt={data._id}
            />
          </Avatar>

          <Stack
            flex="auto"
            style={{ flexShrink: 0 }}
            align="stretch"
            justify="flex-start"
            gap={rem(4)}
          >
            {/* {plan[0].saving.vi_vn} */}
            {data.plans[0].saving?.[locale] ? (
              <Pill
                c="var(--mantine-color-green-6)"
                bg="var(--mantine-color-green-1)"
                px={rem(8)}
                py={rem(0)}
                radius={rem(24)}
                w="fit-content"
              >
                <Text
                  lh={isMobile ? rem(20) : rem(24)}
                  fw={600}
                  size={isMobile ? 'xs' : 'md'}
                >
                  {data.plans[0]?.saving?.[locale]}
                </Text>
              </Pill>
            ) : null}

            <Text
              c="secondary.7"
              w="100%"
              size={isMobile ? 'sm' : 'md'}
              lh={isMobile ? rem(20) : rem(24)}
              fw={700}
              lineClamp={1}
            >
              {data.title[locale]}
            </Text>
            {data.description[locale] && (
              <Text
                w="100%"
                size={isMobile ? 'xs' : 'sm'}
                lh={isMobile ? rem(16) : rem(24)}
                fw={500}
                lineClamp={1}
                c="neutral.6"
              >
                {data.description[locale]}
              </Text>
            )}
            {data.plans?.length && data.plans[0]?.price >= 0 ? (
              <Box mt={4}>
                <Group gap={4}>
                  {/* {data.plans[0].original_price >= 0 ? (
                    <>
                      <Text
                        td="line-through"
                        c="neutral.5"
                        size={isMobile ? 'xs' : 'sm'}
                        lh={rem(16)}
                        fw={500}
                      >
                        {formatCurrency(data.plans[0].original_price)}
                      </Text>{' '}
                      {' |'}
                    </>
                  ) : null} */}
                  <Text
                    c="secondary.6"
                    size={isMobile ? 'sm' : 'md'}
                    lh={isMobile ? rem(20) : rem(24)}
                    fw={600}
                  >
                    {formatCurrency(data.plans[0].price)}
                  </Text>
                  {'/'}
                  {data.plans[0].life_time_in_days >= 0 ? (
                    <>
                      <Text
                        c="neutral.6"
                        size={isMobile ? 'xs' : 'sm'}
                        lh={rem(20)}
                        fw={500}
                      >
                        {data.plans[0].life_time_in_days} ngày
                      </Text>
                    </>
                  ) : null}
                </Group>
              </Box>
            ) : null}
          </Stack>

          <ArrowRightIcon
            style={{ flexShrink: 0, alignSelf: 'center' }}
            width={24}
            height={24}
          />
        </Group>
      </Card.Section>
    </Card>
  );
}
